











































import Vue from 'vue';
import VatsAPI from '@/Shared/VatsAPI';
import {BRow} from 'bootstrap-vue';
import {AutoReportSchedule} from '@/Admin/AutoReportsMaintenance/AutoReportSchedule';
import {AutoReportPeriod} from '@/Admin/AutoReportsMaintenance/AutoReportPeriod';
import {AutoReportName} from '@/Admin/AutoReportsMaintenance/AutoReportName';
import { TranslateResult } from 'vue-i18n';
import { IDefaultGridColumns } from '@/Shared/IDefaultGridColumns';

export default Vue.extend({
    props: ['location'],
    computed: {
        fields(): Array<IDefaultGridColumns<AutoReportSchedule>> {
            return [
                {key: 'report', label: this.$t('admin.autoReportsMaintenance.report')},
                {key: 'period', label: this.$t('admin.autoReportsMaintenance.period')},
                {key: 'recipients', label: this.$t('admin.autoReportsMaintenance.recipients')},
                {key: 'actions', label: this.$t('admin.autoReportsMaintenance.actions')},
            ];
        }
    },
    data() {
        return {
            items: [] as AutoReportSchedule[],
            reports: [] as AutoReportName[],
            periods: [] as AutoReportPeriod[],

            editing: {} as { [key: number]: boolean }, // dict with number keys (recId) and bool value
            itemsEditing: {} as { [key: number]: AutoReportSchedule }
        };
    },
    methods: {
        async getAutoReportNames() {
            const axiosResponse = await VatsAPI.get<AutoReportName[]>(`${this.location}/AutoReportsManagement/AutoReportNames`);
            return axiosResponse.data;
        },

        async getAutoReportPeriods() {
            const axiosResponse = await VatsAPI.get<AutoReportPeriod[]>(`${this.location}/AutoReportsManagement/AutoReportPeriods`);
            return axiosResponse.data;
        },

        async refreshReportsTable() {
            const axiosResponse = await VatsAPI.get<AutoReportSchedule[]>(`${this.location}/AutoReportsManagement`);
            this.items = axiosResponse.data;
        },

        toggleRowEditable(item: AutoReportSchedule) {
            const target = {};
            const source1 = this.editing;
            const source2 = {[item.recId]: !this.editing[item.recId] || item.recId === 0};
            this.editing = Object.assign(target, source1, source2);
        },

        addNewRow() {
            const newItem = new AutoReportSchedule();

            this.items.push(newItem);

            this.toggleRowEditable(newItem);
        },

        beginEditRow(row: BRow) {
            const item: AutoReportSchedule = row.item;

            this.itemsEditing[item.recId] = Object.assign({}, row.item);

            this.toggleRowEditable(item);
        },

        removeItemFromTable(item: AutoReportSchedule) {
            this.items.splice(this.items.indexOf(item), 1);
        },

        cancelEditRow(row: BRow) {
            if (row.item.recId === 0) {
                this.removeItemFromTable(row.item);
                return;
            }

            Object.assign(row.item, this.itemsEditing[row.item.recId]);

            delete this.itemsEditing[row.item.recId];

            this.toggleRowEditable(row.item);
        },

        async upsertRow(row: BRow) {

            const item: AutoReportSchedule = row.item;

            const isNewRow: boolean = item.recId === 0;

            const axiosResponse = await VatsAPI.post<AutoReportSchedule>(`${this.location}/AutoReportsManagement/UpsertAutoReportSchedule`, item);
            const newItem: AutoReportSchedule = axiosResponse.data;

            Object.assign(row.item, newItem);

            if (!isNewRow) {
                this.toggleRowEditable(item);
            }

            return;
        },

        async deleteRow(row: BRow) {
            const item: AutoReportSchedule = row.item;

            if (item.recId !== 0) {
                const msgBoxOptions = {
                    centered: true,
                    okVariant: 'danger',
                    modalClass: 'deleteRowClass',
                    hideBackdrop: true
                };

                const message: TranslateResult =
                    this.$t('admin.autoReportsMaintenance.confirmDeleteMessage',
                        {report: item.report, period: item.period, recipients: item.recipients});

                if (!await this.$bvModal.msgBoxConfirm(message.toString(), msgBoxOptions)) {
                    return;
                }

                // delete selected row from sql
                await VatsAPI.delete(`${this.location}/AutoReportsManagement`, {data: [item]});
            }

            this.removeItemFromTable(item);
        }
    },
    async mounted() {
        this.reports = await this.getAutoReportNames();
        this.periods = await this.getAutoReportPeriods();

        await this.refreshReportsTable();
    },
});

